/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function($) {

	// Remove empty P tags created by WP inside of Accordion and Orbit
	//jQuery('.accordion p:empty, .orbit p:empty').remove();

/*
	if( $('#skrollr-body').length > 0 ) {
  	var s = skrollr.init({
      smoothScrolling: false,
      mobileDeceleration: 0.004
    });
	}
*/
  var rellax = new Rellax('.rellax', {
    speed: -4,
    center: true,
    wrapper: null,
    round: true,
    vertical: true,
    horizontal: false
  });

  if( $('div[data-simple-slider]').length > 0 ) {
    simpleslider.getSlider({
    	container: document.querySelector('*[data-simple-slider]'),
      prop: 'opacity',
      unit: '',
      init: 0,
      show: 1,
      end: 0
    });
  }

});



